import { Flex, Modal, Text, Button } from '@jisr-hr/design-system'
import I18n from 'translations/i18n'
import WrappedIcon from 'components/global/atoms/WrappedIcon/WrappedIcon'
import AttachmentLink from 'components/global/templates/CardTemplate/Attachment'
import { format } from 'date-fns'
import { arSA, enUS } from 'date-fns/locale'
import styles from '../styles.module.css'

type AnnouncementModalProps = {
  attachment?: {
    url: string
    content_type: string
    size: number
    name: string
  } | null
  title?: string
  description?: string
  date?: string
  open: boolean
  onClose: () => void
}

const AnnouncementModal = ({
  open,
  onClose,
  title,
  description,
  attachment,
  date,
}: AnnouncementModalProps): JSX.Element => {
  const locales = { en: enUS, ar: arSA }
  const LOCALE = localStorage.getItem('Locale') ?? 'en'
  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      disableCloseOut
      variant="centerDialog"
      width="440px"
      modalContentStyle={{ padding: 24, borderRadius: 12 }}
      modalHeaderClassName={styles.announcementModalHeader}
      header={
        <Flex
          itemsCenter
          style={{ gap: 12 }}
          data-testid="announcement_modal_header"
        >
          <WrappedIcon
            icon={['fal', 'envelope-open']}
            width={48}
            fontWeight={600}
            color="var(--color-natural-gray-darker-2)"
            background="var(--color-natural-gray-lighter-new)"
            borderColor="var(--color-natural-gray-lightest-1-new)"
          />
          <Flex flexCol>
            <Text
              typography="paragraph16"
              weight="bold"
            >
              {I18n.t('announcement')}
            </Text>
            {date && (
              <Text typography="paragraph16">
                {format(new Date(date), 'EEE, d MMM, yyyy', { locale: locales[LOCALE] })}
              </Text>
            )}
          </Flex>
        </Flex>
      }
      content={
        <>
          <Flex
            flexCol
            style={{ gap: 24 }}
          >
            <Text
              typography="paragraph16"
              weight="bold"
              dangerouslySetInnerHTML={{
                __html: title,
              }}
            />
            <Text
              typography="paragraph16"
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            />
            {attachment && attachment.content_type === 'image/png' && (
              <img
                src={attachment.url}
                alt="avatar"
              />
            )}
            {attachment && attachment.content_type === 'application/pdf' && (
              <div className={styles.attachmentContainer}>
                <AttachmentLink attachment={attachment} />
              </div>
            )}
          </Flex>
          <Flex
            justifyEnd
            style={{ paddingTop: 16 }}
          >
            <Button
              size="medium"
              label={I18n.t('close')}
              onClick={onClose}
              data-testid="close_btn"
            />
          </Flex>
        </>
      }
    />
  )
}

export default AnnouncementModal
